import {
  v2_createGooglePayMethodData,
  v2_useGooglePayConfiguration,
} from '@crocodille/common';
import useSWR from 'swr';

export function usePaymentSupport() {
  const { data: googlePayConfiguration } = v2_useGooglePayConfiguration();

  const { data: canMakeGooglePayPayments } = useSWR(
    googlePayConfiguration
      ? ['canMakeGooglePayPayments', googlePayConfiguration]
      : false,
    async ([_, googlePayConfiguration]) => {
      const paymentRequest = new PaymentRequest(
        [
          {
            supportedMethods: 'https://google.com/pay',
            data: v2_createGooglePayMethodData(googlePayConfiguration),
          },
        ],
        {
          total: {
            label: 'Total',
            amount: {
              currency: 'CZK',
              value: '100.00',
            },
          },
        },
      );

      return await paymentRequest.canMakePayment();
    },
  );

  return { canMakeGooglePayPayments };
}
